export const testimonials = [
  {
    company: 'CoCarting, USA',
    feedback:
      'Oben consistently delivered high-quality mobile and web features that aligned perfectly with our product vision. His React Native and Next.js expertise, combined with strong CI/CD and version control practices, made a significant impact on our release stability and development velocity.',
  },
  {
    company: '7000 Languages, Boston',
    feedback:
      'Oben led our mobile engineering efforts with exceptional professionalism. His architectural decisions, performance improvements, and user experience refinements directly contributed to increased engagement and platform reliability.',
  },
  {
    company: 'Neptune Technologies, USA',
    feedback:
      'Oben demonstrated outstanding frontend engineering capability, architecting scalable React/Next.js solutions and improving deployment workflows using GitHub Actions. His code quality, attention to detail, and collaboration made him a valuable contributor.',
  },
  {
    company: 'Crowdbotics, Berkeley, USA',
    feedback:
      'Oben delivered a production-ready AR mobile experience with impressive technical depth. His mastery of Unity, AR Foundation, and real-time optimization brought creativity and solid engineering discipline to the project’s success.',
  },
];
